import React, { useState, useEffect } from 'react'
import './QrPopup.css'
import Button from '../Button/Button'
import { CustomRoundButton} from '../Button/RoundButton'
import { chevronLeft, chevronUp, xIcon } from '../../Helper/svgs'
import { motion, AnimatePresence } from 'framer-motion'
import goToLink from '../../Helper/GoToLink'
import GoToLinks from '../../Data/GoToLinks'
import AssetImage from '../../Helper/AssetImage'
import AssetImages from '../../Helper/AssetImages'
export default function BottomQrPopup(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [isButtonVisible, setIsButtonVisible] = useState(false);
    
    useEffect(() => {

        const timer = setInterval(() => {
          if (!isOpen) {
            setIsOpen(true);
          }
        }, 15000);
    
        return () => clearInterval(timer);
      }, [isOpen]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const scrollThreshold = 1000; // Adjust this threshold as needed

            if (scrollPosition > scrollThreshold) {
                setIsButtonVisible(true);
            } else {
                setIsButtonVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener on component unmount
        return () => {

            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const togglePopup = () => {
        setIsOpen(!isOpen);
    };

    let buttonIcon = isOpen ? xIcon() : chevronLeft();
    return (
        <div className={`${props.className} bottom-qr-popup container-horizontal res-gap-8`}>
            <AnimatePresence>
                {
                    isOpen &&
                    <QrPopup
                        initial={{
                            scaleX: 0,
                            scaleY: 0,
                            // height: 0,
                            // width: 0,
                            opacity: 0
                        }}
                        animate={{
                            scaleX: 1,
                            scaleY: 1,
                            // height: '100%',
                            // width: '100%',
                            opacity: 1
                        }}
                        exit={{
                            scaleX: 0,
                            scaleY: 0,
                            // height: 0,
                            // width: 0,
                            opacity: 0
                        }}
                        transition={{
                            duration: 0.3
                        }} />
                }
            </AnimatePresence>
            <div className='container-vertical res-gap-8'>
                <AnimatePresence>
                    {
                        isButtonVisible &&
                        <motion.div
                            initial={{
                                scaleX: 0,
                                scaleY: 0,
                                // height: 0,
                                // width: 0,
                                opacity: 0
                            }}
                            animate={{
                                scaleX: 1,
                                scaleY: 1,
                                // height: '100%',
                                // width: '100%',
                                opacity: 1
                            }}
                            exit={{
                                scaleX: 0,
                                scaleY: 0,
                                // height: 0,
                                // width: 0,
                                opacity: 0
                            }}
                            transition={{
                                duration: 0.3
                            }}>
                            <CustomRoundButton

                                content={
                                    chevronUp()
                                }
                                onClick={
                                    () => window.scrollTo(0, 0)
                                }
                                className='left-button' />
                        </motion.div>
                    }
                </AnimatePresence>
                <CustomRoundButton
                    content={
                        buttonIcon
                    }
                    onClick={togglePopup}
                    className='left-button' />
            </div>
        </div>
    )
}

function QrPopup(props) {
    return (
        <motion.div
            initial={props.initial}
            animate={props.animate}
            exit={props.exit}
            transition={props.transition}
            className={`qr-popup container-horizontal ${props.className}`}>
            <div className='qr-code'>
                <AssetImage assetImage={AssetImages.imageWolfInvestmentQrCode} />
            </div>

            <div className='container-vertical res-gap-8'>
                <h6 className='title'>
                    Scan QR Code to Open 100% free Demat Account
                </h6>
                <div className='fw-medium fs-small clr-grey-400'>
                    Or
                </div>
                <Button
                    name='Click Here'
                    className='btn-sz-small'
                    onClick={() => goToLink(GoToLinks.accountOpening)} />
            </div>

        </motion.div>
    )
}
